import React from "react";
import styles from "./Header.module.css";

function Header({ dark, setDark }) {
  return (
    <header className={styles.header} style={{ opacity: 0, animation: "fadeIn 0.6s ease-out forwards" }}>
      <div className={styles.top}>
        <div>
          <h1 className={styles.name}>ashish<span className={styles.dot}>.</span></h1>
        </div>
        <nav className={styles.nav}>
          <button
            className={styles.themeBtn}
            onClick={() => setDark(!dark)}
          >
            {dark ? "☀ light" : "☾ dark"}
          </button>
          <a href="mailto:ashish.hudar@gmail.com" title="Email">MSG</a>
          <a href="https://github.com/ashish921998" target="_blank" rel="noopener noreferrer" title="GitHub">GH</a>
          <a href="http://www.linkedin.com/in/ash921998" target="_blank" rel="noopener noreferrer" title="LinkedIn">IN</a>
          <a href="https://twitter.com/AGI_Tiramisu" target="_blank" rel="noopener noreferrer" title="Twitter/X">X</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
